import { EChartsOption } from "echarts";

import { ChartContext, MlChartType } from "components/ml/types";

import { lineHighlightDecorator, scatterHighlightDecorator } from "./highlight";
import { scatterTooltipDecorator, spearmanCorrelationTooltipDecorator } from "./tooltip";

export interface ChartDecorator {
  decorate: (option: EChartsOption, context: ChartContext) => EChartsOption;
}
export const decoratorMap: Record<MlChartType, ChartDecorator[]> = {
  FeatureImpact: [],
  PredictedVsActual: [scatterHighlightDecorator, scatterTooltipDecorator],
  Residuals: [scatterHighlightDecorator, scatterTooltipDecorator],
  ShapSummary: [scatterTooltipDecorator],
  ShapDependence: [scatterTooltipDecorator],
  Decision: [lineHighlightDecorator],
  Correlation: [spearmanCorrelationTooltipDecorator]
};
export function getDecoratorsForType(type: MlChartType): ChartDecorator[] {
  return decoratorMap[type] || [];
}
